var React = require('react');

function Dagger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 428.84V224h128v204.84l-50.68 76a16 16 0 0 1-26.63 0z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M290.94 192H93.06A47.92 47.92 0 1 1 48 128h112V16a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v112h112a48 48 0 1 1-45.06 64z","className":"fa-primary","key":2})]);
}

Dagger.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Dagger;

Dagger.default = Dagger;
